import React from 'react';
import { CameraOff } from 'lucide-react';

import { CaseReport } from '../../models/CaseTypes';

interface KeyMomentsSectionProps {
  caseReport: CaseReport;
}

export function KeyMomentsSection({ caseReport: _caseReport }: KeyMomentsSectionProps): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
      <CameraOff
        size={60}
        className="text-primary mb-4"
        strokeWidth={1.5}
      />
      <p className="font-medium text-high-emphasis-font mb-2">
        No Key Moments Recorded
      </p>
      <p className="font-normal text-font-700 max-w-md">
        Call out to the Paradigm Clinical Specialists when you would like to capture
        a specific moment from your surgery.
      </p>
    </div>
  );
}
